module.exports = __webpack_public_path__ + "img/6ne.bec99d8f.svg";